import React from 'react';
import Chip from '@material-ui/core/Chip';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        padding: 0.5
    },
    chip: {
        margin: 1,
    }
});

export default function IdeaChip(props) {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {props.ideaData.map((data) => {
                const styleOverride = {
                    backgroundColor: data.color,
                    color: data.textColor ? data.textColor: 'black'
                };
                if ('background' in data) {
                    styleOverride.background = data.background;
                }
                return (
                    <Chip key={data.label} label={data.label} style={styleOverride} className={classes.chip} size='small'/>
                );
            })}
        </div>
    );
}